"use client";

import React, { createContext, ReactNode, useContext } from "react";

export type ServerRenderedCarouselTileBatchType = {
  tileNodes: React.ReactNode[] | undefined;
  batchRenderedPromise: Promise<number> | Promise<unknown>;
};

const ServerRenderedCarouselTilesContext = createContext<{
  firstServerRenderedProductTilesBatch: ServerRenderedCarouselTileBatchType | undefined;
  remainingServerRenderedProductTiles: Promise<ServerRenderedCarouselTileBatchType> | undefined;
  firstBatchSize: number | undefined;
} | undefined>(undefined);

export const useServerRenderedCarouselTiles = () =>
  useContext(ServerRenderedCarouselTilesContext);

export const ServerRenderedCarouselTilesContextProvider = ({
  firstServerRenderedProductTilesBatch,
  remainingServerRenderedProductTiles,
  firstBatchSize,
  children,
}: {
  firstServerRenderedProductTilesBatch: ServerRenderedCarouselTileBatchType,
  remainingServerRenderedProductTiles: Promise<ServerRenderedCarouselTileBatchType>,
  firstBatchSize: number | undefined,
  children: ReactNode;
}) => {
  return (
    <ServerRenderedCarouselTilesContext.Provider
      value={{ firstServerRenderedProductTilesBatch, remainingServerRenderedProductTiles, firstBatchSize }}
    >
      {children}
    </ServerRenderedCarouselTilesContext.Provider>
  );
};